<template>
  <div class="login-bg">
    <!-- <img class="login-logo" src="../../../assets/images/logo.png" alt="logo"> -->
    <div class="login">
      <h1 class="login-title">考试大厅 - 登录</h1>
      <div class="login-box box-shadow">
        <Form ref="$form" :model="form" :rules="rules">
          <FormItem prop="mobile">
            <Input v-model="form.mobile" placeholder="请输入您绑定的手机号" :maxlength="11" />
          </FormItem>
          <FormItem prop="code">
            <div class="login-box-code">
              <Input class="login-box-code-input" v-model="form.code" placeholder="请输入您收到的4位验证码" :maxlength="4" />
              <Button class="login-box-code-button" type="primary" :disabled="TIMER !== timer" @click="handleSendSms" :loading="smsLoading">
                {{ TIMER === timer ? '发送验证码' : timer + ' 秒' }}
              </Button>
            </div>
          </FormItem>
        </Form>
        <Button type="primary" :loading="loginLoading" long @click="handleLogin">立即登录</Button>
        <div class="login-box-extra box-flex margin-top-10px">
          <a class="text-underline" @click.prevent="handleSearchDiploma">证书查询</a>
          <a class="text-underline" @click.prevent="handleLoginHelp">登录帮助</a>
        </div>
      </div>
      <Divider class="login-support">野原之森信息科技提供大陆区域技术支持</Divider>
    </div>

    <Copyright />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mobileValidator, smsCodeValidator } from '../../../libs/validator'
import { USER } from '../../../libs/namespace'
import { SMS_TIMER } from '../../../libs/constant'
import Copyright from '../../../components/Copyright'

let interval
export default {
  name: 'login',
  components: { Copyright },
  data () {
    return {
      TIMER: SMS_TIMER,
      timer: SMS_TIMER,
      smsLoading: false,
      loginLoading: false,
      form: {
        mobile: '',
        code: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请填写您绑定的手机号', trigger: 'blur' },
          { validator: mobileValidator, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请填写4位验证码', trigger: 'blur' },
          { validator: smsCodeValidator, trigger: 'blur' }
        ]
      }
    }
  },
  destroyed () {
    clearInterval(interval)
  },
  handlers: {
    async handleSendSms () {
      if (!await this.validate('mobile')) return
      const { mobile } = this.form
      try {
        this.smsLoading = true
        await this.sendSms(mobile)
        this.timeCounter()
        window.toast.success('【野原之森】验证码已发送，有效期10分钟')
      } catch (err) {
        //
      } finally {
        this.smsLoading = false
      }
    },
    async handleLogin () {
      if (!await this.validate()) return
      try {
        this.loginLoading = true
        await this.login(this.form)
        window.toast.success('登录成功')
        setTimeout(() => {
          this.$router.replace({ name: 'index' })
        }, 1000)
      } catch (err) {
        //
      } finally {
        this.loginLoading = false
      }
    },
    handleSearchDiploma () {
      this.openDialog({
        name: '/dialogs/searchDiploma'
      })
    },
    handleLoginHelp () {
      this.openDialog({
        name: '/user/dialogs/loginHelper'
      })
    }
  },
  methods: {
    ...mapActions(USER, [ 'sendSms', 'login' ]),

    timeCounter () {
      this.timer--
      interval = setInterval(() => {
        if (!this.timer) {
          this.timer = this.TIMER
          clearInterval(interval)
          return
        }
        this.timer--
      }, 1000)
    },
    async validate (field) {
      const $form = this.$refs.$form
      if (field) {
        return new Promise(resolve => {
          $form.validateField('mobile', res => {
            resolve(!res)
          })
        })
      } else {
        return await $form.validate()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: url(../../../assets/images/bg.jpg) no-repeat;
  background-size: cover;
  background-position: center center;

  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: #2e323f;
    opacity: .3;
  }
}
.login {
  position: absolute;
  width: 350px;
  left: 50%;
  top: 20%;
  transform: translateX(-50%);

  &-logo {
    position: absolute;
    left: 20px;
    top: 20px;
    width: 100px;
    height: 100px;
  }
  &-title {
    margin-bottom: 20px;
    font-weight: 300;
    color: #ffffff;
  }
  &-box {
    padding: 30px;
    background: #ffffff;

    &-code {
      display: flex;

      &-input {
        flex: 1;
      }
      &-button {
        flex: none;
        width: 100px;
        margin-left: 10px;
      }
    }
    &-extra {
      justify-content: space-between;
    }
  }

  &-support {
    margin: 10px 0;
    opacity: .8;

    /deep/ .ivu-divider-inner-text {
      color: #ffffff;
    }
  }
}
</style>

